import { render, staticRenderFns } from "./SRPComponentSelector.vue?vue&type=template&id=6fa4d6b1&"
import script from "./SRPComponentSelector.vue?vue&type=script&lang=js&"
export * from "./SRPComponentSelector.vue?vue&type=script&lang=js&"
import style0 from "./SRPComponentSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/work/dealerdraft/dealerdraft/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
